import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const ContentPlanCsvImportPage = lazyWithRetry(() => import('./pages/ContentPlanCsvImportPage'))
const ContentPlanCsvImportRowsPage = lazyWithRetry(
  () => import('./pages/ContentPlanCsvImportRowsPage'),
)
const ContentPlanPage = lazyWithRetry(() => import('./pages/ContentPlanPage'))
const ContentPlanListPage = lazyWithRetry(() => import('./pages/ContentPlanListPage'))
const ContentPlanDetailPage = lazyWithRetry(() => import('./pages/ContentPlanDetailPage'))

const routes: AppRoute[] = [
  {
    path: 'content-plans',
    element: ContentPlanListPage,
    meta: {
      title: 'contentPlan.title',
    },
  },
  {
    path: 'content-plans/new',
    element: ContentPlanPage,
    meta: {
      title: 'contentPlan.title',
    },
  },
  {
    path: 'content-plans/import-csv',
    element: ContentPlanCsvImportPage,
    meta: {
      title: 'contentPlan.csvImport.pageTitle',
    },
  },
  {
    path: 'content-plans/:id/import-csv-rows',
    element: ContentPlanCsvImportRowsPage,
    meta: {
      title: 'contentPlan.csvImport.rowsPageTitle',
    },
  },
  {
    path: 'content-plans/:id',
    element: ContentPlanDetailPage,
    meta: {
      title: 'contentPlan.title',
    },
  },
]

export default routes
